import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { forkJoin } from 'rxjs/observable/forkJoin';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
declare var $: any, moment: any

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent implements OnInit {

  form: FormGroup;
  contactId = ""
  emailSupervisor = "";
  contact: any = {}

  displayStyle = "none";
  countryList: any
  subDistrictList: any
  districtList: any
  provinceList: any
  postalcodeList: any

  PortalLogin: any

  combinedAddressList: any
  filterdAddressList: any

  personalTypeList: any
  companyTypeList: any

  submitted = false

  oldEmail = ""
  countSendMail = 0
  countRowError = 0
  
  role:any = {}
  cookieData: any


  @Output() GetDataSave = new EventEmitter();

  get formControl() {
    return this.form.controls;
  }

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private util: UtilService,
    private activatedRoute: ActivatedRoute
  ) {
    this.form = this.fb.group({
      //username: ['', Validators.required],
      //password: ['', Validators.required]
      email: ['', Validators.required]
    });
   }

  async ngOnInit() {

  }

  async init(id: string) {
    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)


    const thisTs = this
    function matchCustom(params: any, data: any) {

      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        // `params.term` should be the term that is used for searching
        // `data.text` is the text that is displayed for the data object
        if (data.text.indexOf(params.term) > -1) {
          // You can return modified objects from here
          // This includes matching the `children` how you want in nested data sets
          return data;
        }
      }
      // Return `null` if the term should not be displayed
      return null;
    }

    if (this.contactId == "") {
      this.contactId = id

      const thisTs = this
      this.util.ShowWaiting(true)

      console.log("detail on init")

      await this.callApi()
      //await this.initDropdown()
      //await this.initControl()

      $('.select2').select2({
        // matcher: function (term: any, text: any, option: any) {
        //   return option.hasClass('car');
        // }
        matcher: matchCustom
      });

      $(".select2").on("change", function (e: any) {
        thisTs.addressChange(e.target.value)
      })

      

      this.util.ShowWaiting(false)
    }
    
    let tmp_portal: any = await this.apiService.get("crmservice", "getPortalLogin", "contactid=" + this.contactId)
    //console.log(tmp_portal.password);
    if (tmp_portal.password != null && tmp_portal.password != ''){
      $("#btnSend").addClass("sr-only");
    }
  }

  async displayPopup() {
    // boy add
    if (this.role.dpa_name.includes('Supervisor')){
      await this.save();
    }
    else {
      //this.form.controls["username"].setValue("");
      //this.form.controls["password"].setValue("");
      //console.log(this.contactId);
      //console.log(JSON.stringify(this.contact));

      let tmp_userCurrent: any = await this.apiService.get("crmservice", "callcenterProfile", "callcenterId=" + this.cookieData.userId)
      
      let tmp_user: any = await this.apiService.get("crmservice", "callcenterTeamSV", "customwebuserId=" + this.cookieData.userId)
      this.contact.dpa_modifiedby = new Date().toISOString()
              
      let resC: any = await this.apiService.put("crmservice", "contactBeforeSave/" + this.contactId, this.contact)

      
      let reqUpdate: any = {
        email: tmp_userCurrent[0].dpa_emailaddress,
        userId: this.cookieData.userId,
        tokenLog: resC.ticketnumber
      }

      let resC2: any = await this.apiService.post("crmservice", "contactUpdateBeforeSave", reqUpdate)

      if (this.util.isSuccessResponse(resC)){
        //console.log(resC);
        let res: any;
        tmp_user.forEach((a: any) => {
          //console.log(a);
          
          let req: any = {
            username: a.dpa_username,
            email: tmp_userCurrent[0].dpa_emailaddress,
            call_by: "1",
            url: this.util.baseUrl(),
            userid: a.dpa_customwebuserid,
            tokenLog: resC.ticketnumber,
            contactname: tmp_userCurrent[0].dpa_name,
            firstname: this.contact.firstname,
            lastname: this.contact.lastname
          }
          this.SendMailSV(req);
         
        });

        if (this.countRowError == 0) {
          this.util.SuccessDialog("ระบบได้ส่งอีเมลไปยัง Supervisor เพื่ออนุมัติการแก้ไขข้อมูลผู้ติดต่อแล้ว")
          this.countRowError = 0;
          this.countSendMail = 0;
        }
        else {
          this.util.ErrorDialog("ระบบไม่สามารถส่งอีเมลไปยัง Supervisor เพื่ออนุมัติการแก้ไขข้อมูลผู้ติดต่อ กรุณาติดต่อเจ้าหน้าที่")
          this.countRowError = 0;
          this.countSendMail = 0;
        }
      }
      //let tmp_user: any = await this.apiService.get("master", "callcenterTeam");
      //console.log(tmp_user);

      //this.form.controls["email"].setValue("");
      //this.displayStyle = "block";
    }
  }

  async SendMailSV(req: any) {
    let res: any = await this.apiService.postCustom("Crm", "SendMailSupervisor", req)

    if (this.util.isSuccessResponse(res)) {
      this.countSendMail+=1;
    }else{
      this.countRowError+=1;
    }
  }

  async sendMailPortal() {
    this.util.ShowWaiting(true)
    // boy add
    this.PortalLogin = {
      firstname: this.contact.firstname,
      lastname: this.contact.lastname,
      usernameidno: this.contact.dpa_idcard,
      username: this.contact.emailaddress1,
      password: '',
      passwordold1: '',
      isactive: "1",
      customerid: this.contactId,
      createOn: null,
      createBy: null,//localStorage.getItem("AgentBank_Profile"),
      pid: null,
      modifiedOn: null,
      modifiedBy: null,
      usertype: "1",
      call_by: "2",
      url: 'https://dpacustportal.msccrm.com'
    };


    var Res: any = await this.apiService.postCustomApi("user", "ReSendMail", this.PortalLogin);
    if (this.util.isSuccessResponse(Res)) {
      this.util.ShowWaiting(false)
      this.util.SuccessDialog("ระบบได้ส่งอีเมลยืนยันตัวตน สำหรับลงทะเบียนใช้งานระบบ Customer Web Portal แล้ว")
    }
    else {
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("ไม่สามารถส่งอีเมลยืนยันตัวตน สำหรับลงทะเบียนใช้งานระบบ Customer Web Portal ได้ กรุณาติดต่อเจ้าหน้าที่")
    }
  }
  
  closePop() {
    this.displayStyle = "none";
  }

  async authorize() {

    try {
      this.submitted = true
      if(this.form.valid){
        this.util.ShowWaiting(true)
        this.emailSupervisor = this.form.get("email").value;
            let tmp_user: any = await this.apiService.get("crmservice", "callcenterProfile", "email=" + this.form.get("email").value)
            let roleList: any = await this.apiService.get("master", "customwebrole")
            

            let tmpRole = roleList.filter((r:any)=>{
              return r.dpa_customwebroleid == tmp_user[0].dpa_roleid
            })

            if (tmpRole[0].dpa_name.includes('Supervisor')){
              this.contact.dpa_modifiedby = new Date().toISOString()
              
              let resC: any = await this.apiService.put("crmservice", "contactBeforeSave/" + this.contactId, this.contact)
              if (this.util.isSuccessResponse(resC)){
                //console.log(resC);
                let req: any = {
                  username: tmp_user[0].dpa_username,
                  email: this.emailSupervisor,
                  call_by: "1",
                  url: this.util.baseUrl(),
                  userid: tmp_user[0].dpa_customwebuserid,
                  tokenLog: resC.ticketnumber
                }
                let res: any = await this.apiService.postCustom("Crm", "SendMailSupervisor", req)
                if (this.util.isSuccessResponse(res)) {
                  this.util.SuccessDialog("ระบบได้ส่ง email สำหรับกำหนดรหัสผ่านใหม่ไปยัง email ของท่านแล้ว")
                }
                else {
                  this.util.ErrorDialog("ไม่สามารถส่ง email กำหนดรหัสผ่านใหม่ได้ กรุณาติดต่อเจ้าหน้าที่")
                }
              }

              //await this.saveForSendMail();
            }
            else {
              //this.util.WarningDialog("ไม่สามารถบันทึกได้ เนื่องจาก Username นี้ไม่ใช่ Supervisor")
              this.util.WarningDialog("ไม่สามารถส่ง Email ได้ เนื่องจาก Email นี้ไม่ใช่ Supervisor")
            }
            //this.util.ShowWaiting(false)

            this.displayStyle = "none";
        //let res:any = await this.apiService.post("crmservice", "callcenterLogin", this.form.value)
        //if (this.util.isSuccessResponse(res)) {
        //  if(res.RESCODE == "0" && res.RESMSG == "SUCCESS"){
            
            
            //let tmp_user: any = await this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)
            
        //  }
        //  else{
            //this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
        //    this.util.ErrorDialog("Email ไม่ถูกต้อง")
        //  }
        //}
        //else{
          //this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
        //  this.util.ErrorDialog("Email ไม่ถูกต้อง")
        //}
      }

      this.util.ShowWaiting(false)

    } catch (ex) {
      this.util.ShowWaiting(false);
      this.util.ErrorDialog(ex);
    }
  }

  callApi(): Observable<any> {
    return forkJoin([
      this.initDropdown(),
      this.initControl()
    ]);
  }

  async initDropdown() {
    try {
      this.countryList = await this.apiService.get("master", "country")
      this.combinedAddressList = await this.apiService.getMasterAddress()
      this.personalTypeList = await this.apiService.get("master", "personalType")
      this.companyTypeList = await this.apiService.get("master", "companyType")
    }
    catch (e) {
      console.log(e)
    }
  }

  CopyAddress(event: any) {
    if (event.target.checked) {
      this.contact.dpa_contact_subdistict = this.contact.dpa_registration_subdistict
      this.contact.dpa_contact_distict = this.contact.dpa_registration_distict
      this.contact.dpa_contact_province = this.contact.dpa_registration_province
      this.contact.dpa_contact_postcode = this.contact.dpa_registration_postcode
      this.contact.dpa_contact_country = this.contact.dpa_registration_country

      this.contact.dpa_contact_subdistictname = this.contact.dpa_registration_subdistictname
      this.contact.dpa_contact_distictname = this.contact.dpa_registration_distictname
      this.contact.dpa_contact_provincname = this.contact.dpa_registration_provincename
      this.contact.dpa_contact_postcodename = this.contact.dpa_registration_postcodename
      this.contact.dpa_contact_countryname = this.contact.dpa_registration_countryname

      this.contact.dpa_contact_homeno = this.contact.dpa_registration_homeno
      this.contact.dpa_contact_street = this.contact.dpa_registration_street
      this.contact.dpa_contact_moo = this.contact.dpa_registration_moo
    }
  }

  getObjectByKey(objList: any, key: string, value: string) {
    return objList.find((k: any) => k[key] == value);
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts = selected[0].text.split(" | ")

      this.contact.dpa_contact_subdistict = values[0]
      this.contact.dpa_contact_distict = values[1]
      this.contact.dpa_contact_province = values[2]
      this.contact.dpa_contact_postcode = values[3]
      this.contact.dpa_contact_country = values[4]

      this.contact.dpa_contact_subdistictname = texts[0]
      this.contact.dpa_contact_distictname = texts[1]
      this.contact.dpa_contact_provincname = texts[2]
      this.contact.dpa_contact_postcodename = texts[3]
      this.contact.dpa_contact_countryname = texts[4]
    }
    else {
      this.contact.dpa_contact_subdistict = ""
      this.contact.dpa_contact_distict = ""
      this.contact.dpa_contact_province = ""
      this.contact.dpa_contact_postcode = ""
      this.contact.dpa_contact_country = ""

      this.contact.dpa_contact_subdistictname = ""
      this.contact.dpa_contact_distictname = ""
      this.contact.dpa_contact_provincname = ""
      this.contact.dpa_contact_postcodename = ""
      this.contact.dpa_contact_countryname = ""
    }
  }

  close() {
    window.close()
  }

  async getContact() {
    let para = "contactid=" + this.contactId
    let tmp: any = await this.apiService.get("crmservice", "contact", para)
    return tmp[0]
  }

  async initControl() {
    this.util.ShowWaiting(true)

    this.contact = await this.getContact()

    this.oldEmail = this.contact.emailaddress1

    this.GetDataSave.emit(this.contact);

    this.util.ShowWaiting(false)
  }

  async save() {
    this.submitted = true
    if (this.isFormValid()) {
      this.util.ShowWaiting(true)

      this.contact.dpa_modifiedby = new Date().toISOString()

      let res: any = await this.apiService.put("crmservice", "contact/" + this.contactId, this.contact)
      if (this.util.isSuccessResponse(res)) {
        this.GetDataSave.emit(this.contact);

        await this.registerDROS()

        if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.contact.emailaddress1) {

          let updateSucceed = this.updatePortalLogin()

          // this.SendNewEmail()
          // this.SendOldEmail()
          let notiReq = {
            firstname: this.contact.firstname,
            lastname: this.contact.lastname,
            callBy: "1",
            newMail: this.contact.emailaddress1,
            oldMail: this.oldEmail
          }
          this.apiService.postCustom("crm", "NotiEmailChange", notiReq)
        }

        this.util.SuccessDialog("แก้ไขข้อมูลสำเร็จ")
      }
      else {
        this.util.ErrorDialog("แก้ไขข้อมูลไม่สำเร็จ")
      }

      this.util.ShowWaiting(false)
    }
  }

  

  isFormValid() {
    if(this.contact.emailaddress1 == null){
      this.contact.emailaddress1 = ""
    }
    if(this.contact.telephone1 == null){
      this.contact.telephone1 = ""
    }
    if(this.contact.dpa_contact_homeno == null){
      this.contact.dpa_contact_homeno = ""
    }
    if(this.contact.dpa_contact_country == null){
      this.contact.dpa_contact_country = ""
    }

    return this.contact.emailaddress1 != null &&
      this.contact.emailaddress1.trim().length > 0 &&
      this.isValidMail(this.contact.emailaddress1.trim()) &&
      this.contact.telephone1 != null &&
      this.contact.telephone1.trim().length > 0
  }

  isValidMail(mail: string) {
    if (mail) {
      const matches = mail.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? true : false;
    } else {
      return true;
    }
  }

  // async SendNewEmail() {
    
  //   let MailObj: any = {
  //     dpa_name: "อีเมลของท่านได้รับการเปลี่ยนแล้ว",
  //     dpa_emailaddress: this.contact.emailaddress1
  //   };

  //   var MailContent = "เรียน คุณ" + this.contact.firstname + " " + (this.contact.lastname || "" ) + "<br /><br />" +
  //     "   อีเมลนี้ของคุณได้รับการบันทึกในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
  //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด  <br /><br />" +
  //     "ขอแสดงความนับถือ <br />" +
  //     "สถาบันคุ้มครองเงินฝาก <br />" +
  //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
  //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
  //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
  //     "โทร : 02-272-0300";
  //   MailObj.dpa_description = MailContent;
  //   MailObj.dpa_callby = 1
  //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
  //   return Res;
  // }

  // async SendOldEmail() {

  //   let MailObj: any = {
  //     dpa_name: "อีเมลของท่านได้ถูกเปลี่ยนแล้ว",
  //     dpa_emailaddress: this.oldEmail
  //   };

  //   var MailContent = "เรียน คุณ" + this.contact.firstname + " " + (this.contact.lastname || "" ) + "<br /><br />" +
  //     "   อีเมลของคุณได้เปลี่ยนในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
  //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด <br /><br />" +
  //     "ขอแสดงความนับถือ <br />" +
  //     "สถาบันคุ้มครองเงินฝาก <br />" +
  //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
  //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
  //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
  //     "โทร : 02-272-0300";
  //   MailObj.dpa_description = MailContent;
  //   MailObj.dpa_callby = 1
  //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
  //   return Res;
  // }

  async registerDROS() {
    let idcard = this.contact.dpa_idcard;
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para);
    if (!this.util.IsNullOrUndefined(tmp.CRM06)) {
      let UID = tmp.CRM06.UID;
      let SubdistictCode: string = "";
      let PostalName: string = "";
      let SubdistictObj = await this.apiService.postCustomApi("master", "Subdistrict", { id: this.contact.dpa_contact_subdistict});
      let PostalObj = await this.apiService.postCustomApi("master", "Postalcode", { id: this.contact.dpa_contact_postcode });
      if (!this.util.IsNullOrUndefined(SubdistictObj)) { SubdistictCode = SubdistictObj[0].dpa_code; }
      if (!this.util.IsNullOrUndefined(PostalObj)) { PostalName = PostalObj[0].dpa_name; }
      let arrAddr: any = [];
      let rowAddr: any = {
        addressType: "2",
        addressNo: this.contact.dpa_contact_homeno,
        villageName: null,
        floor: null,
        mooNo: this.contact.dpa_contact_moo,
        soiName: null,
        streetName: this.contact.dpa_contact_street,
        locationCode: SubdistictCode,
        zipcode: PostalName
      }

     let birthdateYYYYMMDD = ""
     if(this.contact.birthdate != "")
     {
      birthdateYYYYMMDD = moment(this.contact.birthdate).format("YYYY/MM/DD") ;
     }

      arrAddr.push(rowAddr);
      let rowSave: any = {
        uid: UID,
        idNo: idcard,
        title: null,
        firstName:  this.contact.firstname ,
        lastName:  this.contact.lastname,
        birthdate: birthdateYYYYMMDD ,
        mobileNo:  this.contact.telephone1,
        email: this.contact.emailaddress1 ,
        address: arrAddr
      }
      //console.log(rowSave);
      let Res = await this.apiService.post("DROS", "register", rowSave);
      //console.log(Res);


    }

  }
  async updatePortalLogin(){
    let req: any = {
      username: this.contact.emailaddress1,
      usernameidno: this.contact.dpa_idcard,
      oldEmail: this.oldEmail
    }

    let res: any = await this.apiService.postCustom("User", "UpdateEmailLogin", req)

    if(this.util.isSuccessResponse(res)){
      return true
    }
    else{
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-detail/customer-detail.component.ts